import { useEffect, useState } from "react";
import api from "@/lib/api";
import Layout from "@/components/Layout";
import { Megaphone, CalendarDays } from "lucide-react";

const fmtDate = (d) => {
  const dt = new Date(`${d}T12:00:00`);
  return isNaN(dt) ? d : dt.toLocaleDateString(undefined, { weekday: "long", year: "numeric", month: "long", day: "numeric" });
};

const Bold = ({ text }) =>
  text.split("**").map((part, i) => (i % 2 ? <strong key={i} className="font-semibold text-foreground">{part}</strong> : <span key={i}>{part}</span>));

export default function WhatsNew() {
  const [days, setDays] = useState(null);

  useEffect(() => {
    api.get("/changelog").then((r) => setDays(r.data.days || [])).catch(() => setDays([]));
  }, []);

  return (
    <Layout>
      <div className="max-w-3xl mx-auto" data-testid="whats-new-page">
        <span className="inline-flex items-center gap-1.5 text-[11px] font-bold uppercase tracking-widest text-primary bg-primary/10 border border-primary/20 rounded-full px-3 py-1">
          <Megaphone className="h-3.5 w-3.5" /> What's new
        </span>
        <h1 className="font-display text-4xl sm:text-5xl font-extrabold tracking-tight mt-3">Improvements, dated.</h1>
        <p className="text-muted-foreground mt-2 max-w-xl">A running record of everything that's been added or improved in PMO Maestro — newest first.</p>

        {days === null && <p className="text-muted-foreground mt-10" data-testid="whats-new-loading">Loading…</p>}
        {days !== null && days.length === 0 && <p className="text-muted-foreground mt-10" data-testid="whats-new-empty">No entries yet — check back soon.</p>}

        <div className="mt-10 space-y-10">
          {(days || []).map((d) => (
            <section key={d.date} data-testid={`whats-new-day-${d.date}`}>
              <h2 className="flex items-center gap-2 text-sm font-bold uppercase tracking-widest text-muted-foreground">
                <CalendarDays className="h-4 w-4 text-primary" /> {fmtDate(d.date)}
              </h2>
              <div className="mt-3 space-y-4 border-l-2 border-border pl-5 ml-1.5">
                {d.entries.map((e, i) => (
                  <article key={i} className="rounded-xl border border-border bg-card p-5" data-testid={`whats-new-entry-${d.date}-${i}`}>
                    <h3 className="font-display text-lg font-extrabold tracking-tight">{e.title}</h3>
                    <ul className="mt-2 space-y-1.5">
                      {e.bullets.map((b, k) => (
                        <li key={k} className="text-sm text-muted-foreground leading-relaxed flex gap-2">
                          <span className="mt-[7px] h-1.5 w-1.5 rounded-full bg-primary/50 shrink-0" />
                          <span><Bold text={b} /></span>
                        </li>
                      ))}
                    </ul>
                  </article>
                ))}
              </div>
            </section>
          ))}
        </div>
      </div>
    </Layout>
  );
}
